import type { ComponentType, SVGProps } from 'react'
import { cn } from '@/shared/utils/cn'

type HeroIcon = ComponentType<SVGProps<SVGSVGElement> & { title?: string; titleId?: string }>

interface IconProps {
  icon: HeroIcon
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const sizeMap = {
  xs: 'h-3.5 w-3.5',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
  xl: 'h-8 w-8',
}

export function Icon({ icon: Component, size = 'md', className }: IconProps) {
  return <Component className={cn(sizeMap[size], className)} />
}
